import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { registerField } from 'core/forms';

import { RadioInput, DependentRadioSets } from 'uikit/inputs';

import styles from '../styles/formFieldAccessRule.module.scss';

const FormFieldAccessRule = ({ fieldId, fieldKey, schema = {}, value = {}, updateField }) => {
  const { accessOptions = [], enforcementOptions = [] } = schema;
  const [accessKey, enforcementKey, resetAccessValue] = ['access', 'enforcement_rule', 'off'];
  // Check if the first set (access) is set to "off" to disable the second set
  const isEnforcementDisabled = value?.[accessKey] === resetAccessValue;

  const radioSets = [
    <RadioInput
      className={styles.radioInput}
      key={accessKey}
      fieldId={`${fieldId}-${accessKey}`}
      fieldKey={`${fieldKey}.${accessKey}`}
      options={accessOptions.map((option) => ({
        value: option.value,
        label: i18n.t(option.label),
      }))}
      value={value?.[accessKey] || schema.defaultInputValue || accessOptions[0].value || ''}
      updateField={(val) => {
        const updates = {
          ...value,
          [accessKey]: val,
        };

        if (val === resetAccessValue && updates[enforcementKey]) {
          // If access is set to 'off', remove enforcement rule
          delete updates[enforcementKey];
        } else if (val !== resetAccessValue && !updates[enforcementKey]) {
          // If changing access to on, set enforcement rule to the first enforcement rule option
          updates[enforcementKey] = enforcementOptions[0].value;
        }

        updateField(updates);
      }}
    />,

    <RadioInput
      className={styles.radioInput}
      key={enforcementKey}
      fieldId={`${fieldId}-${enforcementKey}`}
      fieldKey={`${fieldKey}.${enforcementKey}`}
      options={enforcementOptions.map((option) => ({
        value: option.value,
        label: i18n.t(option.label),
      }))}
      value={
        value?.[enforcementKey] || schema.defaultInputValue || enforcementOptions[0].value || ''
      }
      isDisabled={isEnforcementDisabled}
      updateField={(val) => {
        updateField({
          ...value,
          [enforcementKey]: val,
        });
      }}
    />,
  ];

  return <DependentRadioSets className={schema.className} radioSets={radioSets} />;
};

FormFieldAccessRule.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    accessOptions: PropTypes.arrayOf(PropTypes.string),
    enforcementOptions: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    defaultInputValue: PropTypes.string,
  }),
  value: PropTypes.shape({}),
  updateField: PropTypes.func.isRequired,
};

registerField('AccessRule', React.memo(FormFieldAccessRule));

export default FormFieldAccessRule;
